/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const __vue_script__ = {
    name: 'LandingPagePreviewBackground',
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',{staticClass:"landing-page-preview-background"},[_c('rect',{attrs:{"fill":"#DDDDDD","rx":"3","height":"11","width":"47","y":"429","x":"137"}}),_c('path',{attrs:{"fill":"#E3E6E8","d":"M137 450.234C137 449 138 448 139.234 448H411.766C413 448 414 449 414 450.234V461.766C414 463 413 464 411.766 464H139.234C138 464 137 463 137 461.766V450.234Z"}}),_c('rect',{attrs:{"fill":"#DDDDDD","rx":"3","height":"11","width":"215","y":"285","x":"137"}}),_c('rect',{attrs:{"fill":"#F3F3F3","rx":"3","height":"11","width":"277","y":"307","x":"137"}}),_c('rect',{attrs:{"fill":"#F3F3F3","rx":"3","height":"11","width":"277","y":"341","x":"137"}}),_c('rect',{attrs:{"fill":"#F3F3F3","rx":"3","height":"11","width":"277","y":"383","x":"137"}}),_c('rect',{attrs:{"fill":"#F3F3F3","rx":"3","height":"11","width":"277","y":"324","x":"137"}}),_c('rect',{attrs:{"fill":"#F3F3F3","rx":"3","height":"11","width":"193","y":"358","x":"137"}}),_c('rect',{attrs:{"fill":"#F3F3F3","rx":"3","height":"11","width":"78","y":"400","x":"137"}}),_c('rect',{attrs:{"fill":"white","rx":"6.49194","height":"84.4355","width":"279.435","y":"348.282","x":"431.282"}}),_c('rect',{attrs:{"fill":"#DDDDDD","rx":"3","height":"11","width":"74","y":"357.032","x":"440.032"}}),_c('rect',{attrs:{"fill":"#F3F3F3","rx":"3","height":"11","width":"234","y":"376.032","x":"440.032"}}),_c('rect',{attrs:{"stroke-width":"0.564516","stroke":"#DDDDDD","rx":"6.49194","height":"84.4355","width":"279.435","y":"348.282","x":"431.282"}}),_c('rect',{attrs:{"fill":"#DDDDDD","rx":"3","height":"11","width":"167","y":"296","x":"485"}}),_c('rect',{attrs:{"stroke-width":"0.564516","stroke":"#DDDDDD","rx":"6.49194","height":"53.629","width":"279.435","y":"285.282","x":"431.282"}}),_c('g',{staticStyle:{"display":"none"}},[_c('path',{attrs:{"fill":"white","d":"M88 104C88 99.5817 91.5817 96 96 96H752C756.418 96 760 99.5817 760 104V838H88V104Z"}}),_c('rect',{attrs:{"fill":"white","rx":"7.75","height":"74.5","width":"276.5","y":"470.25","x":"137.25"}}),_c('rect',{attrs:{"fill":"#DDDDDD","rx":"3","height":"9","width":"37","y":"507","x":"147"}}),_c('rect',{attrs:{"fill":"#DDDDDD","rx":"3","height":"11","width":"117","y":"493","x":"147"}}),_c('rect',{attrs:{"fill":"#F7F7F7","rx":"3","height":"10","width":"97","y":"480","x":"147"}}),_c('circle',{attrs:{"fill":"#C4C4C4","r":"9","cy":"529","cx":"158"}}),_c('circle',{attrs:{"fill":"#C4C4C4","r":"9","cy":"529","cx":"179"}}),_c('rect',{attrs:{"stroke-width":"0.5","stroke":"#DDDDDD","rx":"7.75","height":"74.5","width":"276.5","y":"470.25","x":"137.25"}}),_c('rect',{attrs:{"fill":"white","rx":"8","height":"75","width":"277","y":"556","x":"137"}}),_c('rect',{attrs:{"fill":"#DDDDDD","rx":"5","height":"11","width":"205","y":"579","x":"147"}}),_c('rect',{attrs:{"fill":"#F7F7F7","rx":"5","height":"10","width":"97","y":"566","x":"147"}}),_c('rect',{attrs:{"stroke-width":"0.5","stroke":"#DDDDDD","rx":"7.75","height":"74.5","width":"276.5","y":"556.25","x":"137.25"}})])])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "LandingPagePreviewBackground.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__